export const formatCents = (cents: number) => {
  const sign = cents >= 0 ? '' : '-';
  return `${sign}$${Math.abs(cents) / 100}`;
};
